/**
 * Line icons of the Theme card (Figma: Material Symbols / capsule set, 20px). Kept
 * apart from the kit's main icons — names like `home` differ in drawing there.
 */
const files = import.meta.glob('@/assets/quiz/icons/*.svg', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>

const icons: Record<string, string> = Object.fromEntries(
  Object.entries(files).map(([path, svg]) => [path.split('/').pop()!.replace('.svg', ''), svg]),
)

export function fairThemeIconSvg(name: string): string {
  return icons[name] ?? ''
}
